import { render } from "./ChatTextField.vue?vue&type=template&id=3c4f8708&scoped=true&bindings={}"
import script from "./ChatTextField.vue?vue&type=script&lang=ts"
export * from "./ChatTextField.vue?vue&type=script&lang=ts"

import "./ChatTextField.vue?vue&type=style&index=0&id=3c4f8708&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c4f8708"

export default script